import React, { useRef } from 'react';
import Service from '../../Service';
import ServiceInfo from '../../ServiceInfo';
import SectionHeading from '../../SectionHeading';
import Slider from 'react-slick';

export default function ServiceSection({
  sectionTitleUp,
  sectionTitle,
  sectionSubTitle,
  sectionTitleDown,
  sectionBtnText,
  sectionBtnUrl,
  data,
  textVariant,
}) {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="container">
      {sectionTitle && (
        <SectionHeading
          sectionTitleUp={sectionTitleUp}
          sectionTitle={sectionTitle}
          sectionSubTitle={sectionSubTitle}
        />
      )}

      <div className="cs_gap_24 cs_mt_40">
        <Slider ref={sliderRef} {...settings} className="cs_slider_activate">
          {data?.map((item, index) => (
            <div key={index}>
              <Service {...item} />
            </div>
          ))}
        </Slider>
      </div>
      <ServiceInfo
        sectionTitleDown={sectionTitleDown}
        sectionBtnText={sectionBtnText}
        sectionBtnUrl={sectionBtnUrl}
        textVariant={textVariant}
      />
    </div>
  );
}
